module.exports = __webpack_public_path__ + "assets/img/img-course-plan01.bfb833a5.png";